import { render, staticRenderFns } from "./ItemHome.vue?vue&type=template&id=4848b993&scoped=true&"
import script from "./ItemHome.vue?vue&type=script&lang=js&"
export * from "./ItemHome.vue?vue&type=script&lang=js&"
import style0 from "./ItemHome.vue?vue&type=style&index=0&id=4848b993&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4848b993",
  null
  
)

export default component.exports